import { observer } from 'mobx-react-lite'
import React from 'react'

import { BrandImage } from '@/components/BrandImage'
import { DisplayGameCode } from '@/components/DisplayGameCode'

import { DisplayQrCode } from './DisplayQrCode'
import { NumbersBoard } from '../../numbers/NumbersBoard'

type JumbotronNumbersProps = {
  enableBrandImage: boolean
  enableGameCode: boolean
  enableQRCode: boolean
  enableQRCodeFullscreen: boolean
  showGameInfo: boolean
}
export const JumbotronNumbers = observer(
  ({
    enableBrandImage,
    enableGameCode,
    enableQRCode,
    enableQRCodeFullscreen,
    showGameInfo
  }: JumbotronNumbersProps) => {
    return (
      <>
        {showGameInfo && (
          <div className='flex w-full items-center justify-between gap-8 overflow-hidden p-8'>
            <div className='w-32'>{enableBrandImage && <BrandImage />}</div>

            {enableGameCode && (
              <div className='mx-auto flex items-center justify-center sm:ml-auto lg:mr-0'>
                <DisplayGameCode />
              </div>
            )}

            {enableQRCode && (
              <div>
                <DisplayQrCode className='m-auto rounded-xl' />
              </div>
            )}
          </div>
        )}

        {enableQRCode && enableQRCodeFullscreen ? <DisplayQrCode isFullscreen /> : <NumbersBoard />}
      </>
    )
  }
)
